/* ─────────────────────────────────────────────────────────────────────────────
   ERP_menu.js — EOH Navigation Engine
   Upload to Shopify → Assets
   Called from every public page via:  <script src="{{ 'ERP_menu.js' | asset_url }}"></script>

   What it does:
   1. Fetches nav config from app-settings (no credentials, public endpoint)
   2. Builds #nav-links (main nav) dynamically
   3. Builds #portal-dd (portal login dropdown) dynamically
   4. Shows logged-in user avatar/name from localStorage (no API call needed)
   5. Falls back to hardcoded defaults if fetch fails — site never breaks
───────────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var API = 'https://erp-ai-backend.vercel.app';

  /* ── Defaults (used if nothing saved in DB yet) ─────────────────────────── */
  var DEFAULTS = {
    main: [
      { label: 'Home',        url: '/',                        active: true, sort: 1 },
      { label: 'Platform',    url: '/pages/erp-chat',          active: true, sort: 2 },
      { label: 'Learning',    url: '/pages/eoh-learning-hub',  active: true, sort: 3 },
      { label: 'Consultants', url: '/pages/consultant-portal', active: true, sort: 4 },
      { label: 'About',       url: '/pages/about',             active: true, sort: 5 },
      { label: 'FAQ',         url: '/pages/qas',               active: true, sort: 6 },
      { label: 'Careers',     url: '/pages/careers',           active: true, sort: 7 },
      { label: 'Contact',     url: '/pages/contact',           active: true, sort: 8 }
    ],
    portal: [
      { label: 'Consultant Login',  url: '/pages/eoh-team-login', sub: 'ERP Consultant workspace',    color: '#0ea5e9', active: true, sort: 1 },
      { label: 'ERP Manager Login', url: '/pages/erp-login',       sub: 'AI platform & project tools', color: '#0fb574', active: true, sort: 2 },
      { label: 'Client Login',      url: '/pages/erp-client',      sub: 'Project tracking & tickets',  color: '#f59e0b', active: true, sort: 3 }
    ]
  };

  /* ── Helpers ────────────────────────────────────────────────────────────── */
  function parseArr(raw, fallback) {
    try {
      var arr = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (Array.isArray(arr) && arr.length) {
        return arr.sort(function (a, b) { return (a.sort || 0) - (b.sort || 0); });
      }
    } catch (_) {}
    return JSON.parse(JSON.stringify(fallback));
  }

  function currentPath() { return window.location.pathname; }

  /* ── Build main nav ─────────────────────────────────────────────────────── */
  function buildMainNav(links) {
    var el = document.getElementById('nav-links');
    if (!el) return;
    var cur = currentPath();
    el.innerHTML = links
      .filter(function (l) { return l.active !== false; })
      .map(function (l) {
        var active = (l.url === '/' ? cur === '/' : cur.indexOf(l.url) === 0) ? ' class="on"' : '';
        return '<a href="' + l.url + '"' + active + '>' + l.label + '</a>';
      })
      .join('');
  }

  /* ── Build portal dropdown ──────────────────────────────────────────────── */
  function buildPortalDrop(items) {
    var el = document.getElementById('portal-dd');
    if (!el) return;
    el.innerHTML = '<div class="portal-dd-head">Portal Login</div>'
      + items
        .filter(function (i) { return i.active !== false; })
        .map(function (i) {
          var c = i.color || '#0ea5e9';
          var letter = (i.label || '?')[0].toUpperCase();
          return '<a href="' + i.url + '" class="portal-dd-item" style="--item-c:' + c + '">'
            + '<div class="pdi-icon" style="background:' + c + '22;color:' + c + '">' + letter + '</div>'
            + '<div>'
            + '<div class="pdi-label">' + i.label + '</div>'
            + (i.sub ? '<div class="pdi-sub">' + i.sub + '</div>' : '')
            + '</div></a>';
        })
        .join('');
  }

  /* ── Build user avatar in nav (from localStorage, no API needed) ────────── */
  function buildUserNav() {
    try {
      var u = JSON.parse(localStorage.getItem('eoh_user') || 'null');
      if (!u || !u.name) return;
      var el = document.getElementById('nav-auth');
      if (!el) return;
      var isAdmin = !!sessionStorage.getItem('eoh_admin_s_t');
      var init = u.name[0].toUpperCase();
      var ava  = u.avatar || '';
      el.innerHTML =
        '<div class="nav-ava-wrap" onclick="EOH_NAV.toggleUser()" id="nav-ava-w">'
        + (ava
          ? '<img src="' + ava + '" class="nav-ava" onerror="this.style.display=\'none\';document.getElementById(\'nav-init\').style.display=\'flex\'">'
          : '')
        + '<div class="nav-init" id="nav-init" style="' + (ava ? 'display:none' : '') + '">' + init + '</div>'
        + '<div class="nav-dd" id="nav-dd">'
        + '<div class="ndd-head"><div class="ndd-name">' + u.name + '</div></div>'
        + '<a href="/pages/erp-chat" class="ndd-a">Platform</a>'
        + '<a href="/pages/eoh-learning-hub" class="ndd-a">Learning Hub</a>'
        + (isAdmin ? '<a href="/pages/wael" class="ndd-a">Admin Panel</a><a href="/pages/menus-all" class="ndd-a">Navigation Manager</a>' : '')
        + '<div class="ndd-div"></div>'
        + '<a href="/pages/erp-chat?signout=1" class="ndd-a ndd-out">Sign Out</a>'
        + '</div></div>';
      /* close on outside click */
      document.addEventListener('click', function (e) {
        var w = document.getElementById('nav-ava-w');
        if (w && !w.contains(e.target)) {
          var d = document.getElementById('nav-dd');
          if (d) d.classList.remove('open');
        }
      });
    } catch (_) {}
  }

  /* ── Apply config ───────────────────────────────────────────────────────── */
  function apply(raw) {
    buildMainNav(parseArr(raw.nav_main,   DEFAULTS.main));
    buildPortalDrop(parseArr(raw.nav_portal, DEFAULTS.portal));
  }

  /* ── Init ───────────────────────────────────────────────────────────────── */
  function init() {
    /* Always show user avatar immediately (localStorage, instant) */
    buildUserNav();

    /* Fetch nav config — public endpoint, no credentials */
    fetch(API + '/admin/app-settings')
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) { apply(d.settings || d); })
      .catch(function () { apply({}); }); /* silent fallback to defaults */
  }

  /* ── Public API ─────────────────────────────────────────────────────────── */
  window.EOH_NAV = {
    toggleUser: function () {
      var d = document.getElementById('nav-dd');
      if (d) d.classList.toggle('open');
    },
    togglePortal: function () {
      var d = document.getElementById('portal-dd');
      if (d) d.classList.toggle('open');
    }
  };

  /* ── Portal outside-click ───────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = document.getElementById('portal-btn');
    if (btn && !btn.contains(e.target)) {
      var d = document.getElementById('portal-dd');
      if (d) d.classList.remove('open');
    }
  });

  /* ── Run on DOM ready ───────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
